import { API_ROOT_URL } from 'envs/_current/config'
import { codiDocumentSchema, reportSchema } from './schema'
import { createListTransform } from './utils/createListTransform'
import { createTransform } from './utils/createTransform'

export const report_getById_Api = {
  backend: `Route::get('error-reports/{id}/get', 'ReportController@getById');`,
  root: API_ROOT_URL,
  path: '/error-reports/:id/get',
  method: 'GET',
  schema: reportSchema,
  transform: createTransform(reportSchema, 'data'),
}

export const report_getDefaultReasons_Api = {
  backend: `Route::get('error-reports/reasons/{type}/get-default-reasons', 'ReportController@getDefaultReasons');`,
  root: API_ROOT_URL,
  path: '/error-reports/reasons/:type/get-default-reasons',
  method: 'GET',
}

export const report_getReportsByOwner_Api = {
  backend: `Route::get('error-reports/{type}/{id}/gets', 'ReportController@getErrorReportByTypeId');`,
  root: API_ROOT_URL,
  path: '/error-reports/:type/:id/gets',
  method: 'GET',
  paramsFields: ['sort_by', 'keyword', 'status', 'report_default_reason_id'],
  schema: reportSchema,
  transform: createListTransform(reportSchema),
}

export const report_getReportsByType_Api = {
  backend: `Route::get('error-reports/{type}/gets', 'ReportController@getErrorReportByType');`,
  root: API_ROOT_URL,
  path: '/error-reports/:type/gets',
  method: 'GET',
  paramsFields: ['sort_by', 'keyword', 'status', 'report_default_reason_id'],
  schema: reportSchema,
  transform: createListTransform(reportSchema),
}

export const report_getAuthErrorReports_Api = {
  backend: `Route::get('auth/error-reports/gets', 'ReportController@getAuthErrorReports');`,
  root: API_ROOT_URL,
  path: '/auth/error-reports/gets',
  method: 'GET',
  paramsFields: ['sort_by', 'keyword', 'status', 'report_default_reason_id'],
  schema: reportSchema,
  transform: createListTransform(reportSchema),
}

export const report_createReport_Api = {
  backend: `Route::post('auth/error-reports/add', 'ReportController@createReport');`,
  root: API_ROOT_URL,
  path: '/auth/error-reports/add',
  method: 'POST',
  schema: reportSchema,
  transform: createTransform(codiDocumentSchema, 'data'),
}

export const report_cancelReport_Api = {
  backend: `Route::post('auth/error-reports/{id}/cancel', 'ReportController@cancelReport');`,
  root: API_ROOT_URL,
  path: '/auth/error-reports/:id/cancel',
  method: 'POST',
  schema: reportSchema,
  transform: createTransform(codiDocumentSchema, 'data'),
}

export const report_manageApproveReport_Api = {
  backend: `Route::post('auth/error-reports/{id}/manage-approve', 'ReportController@manageApproveReport');`,
  root: API_ROOT_URL,
  path: '/auth/error-reports/:id/manage-approve',
  method: 'POST',
  schema: reportSchema,
  transform: createTransform(reportSchema, 'data'),
}

export const report_manageRejectReport_Api = {
  backend: `Route::post('auth/error-reports/{id}/manage-reject', 'ReportController@manageRejectReport');`,
  root: API_ROOT_URL,
  path: '/auth/error-reports/:id/manage-reject',
  method: 'POST',
  schema: reportSchema,
  transform: createTransform(reportSchema, 'data'),
}

export const report_manageDeleteReport_Api = {
  backend: `Route::post('auth/error-reports/{id}/manage-delete', 'ReportController@manageDeleteReport');`,
  root: API_ROOT_URL,
  path: '/auth/error-reports/:id/manage-delete',
  method: 'POST',
  schema: reportSchema,
  transform: createTransform(reportSchema, 'data'),
}

export const report_manageResetReport_Api = {
  backend: `Route::post('auth/error-reports/{id}/manage-undo-approve', 'ReportController@manageUndoApproveReport');`,
  root: API_ROOT_URL,
  path: '/auth/error-reports/:id/manage-undo-approve',
  method: 'POST',
  schema: reportSchema,
  transform: createTransform(reportSchema, 'data'),
}
